

import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import toonflix from "../images/toonflix.jpg";
import { base_url_toonflix } from '../Api/api';
import Cookies from "js-cookie";


const Otp = () => {

  const [input1, setInput1] = useState('');
  const [input2, setInput2] = useState('');
  const [input3, setInput3] = useState('');
  const [input4, setInput4] = useState('');
  const [loading, setLoading] = useState(false);
  const [tVal, setTVal] = useState(null);
// const tVal = Cookies.get("t");
  const [time, setTime] = useState(60);
  const [show, setShow] = useState(false);

  const pack = Cookies.get('pack');
  const msisdn = Cookies.get('number');
  var extId = Cookies.get('extId');

  const navigate = useNavigate();

  const urlParams = new URLSearchParams(window.location.search);
  // otpId passed from Login as ?otpId=...
  const otpId = urlParams.get('otpId') || urlParams.get('id');

  console.log('OTP page — otpId:', otpId, 'msisdn:', msisdn, 'extId:', extId, 'pack:', pack);

 const getScript = async () => {
    setLoading(true);
    try {
      const res = await axios.post(`${base_url_toonflix}/api/v1/evina/script`, {
        serviceName: "ToonFlix",
        extId: extId
      });

      console.log("Evina script response:", res.data);

      // res.data is an object: { t: '...', response: '{"t":"...","s":"<script>"}' }
      const parsed = JSON.parse(res.data.response);
      const scriptContent = parsed.s;
      const tValue = parsed.t;

       setTVal(tValue);

// console.log("t value:", tValue);

      if (scriptContent) {
        let top_head = document.getElementsByTagName("head")[0];
        let anti_script = document.createElement("script");
        anti_script.innerHTML = scriptContent;
        top_head.insertBefore(anti_script, top_head.firstChild);

        var event = new Event("DCBProtectRun");
        document.dispatchEvent(event);
        document.addEventListener("gateway-load", (event) => {
          console.log(event, "EVENT LOADED");
        });
      }

      // Show the pack selector UI after script is loaded
      setShow(true);

    } catch (error) {
      console.error("Error fetching Evina script", error);
      setShow(true); // still show UI so user can try subscribing
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getScript();
  }, []);

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      borderColor: state.isFocused ? 'rgb(234 88 12)' : 'gray',
      boxShadow: state.isFocused ? '0 0 0 1px rgb(234 88 12)' : 'none',
      '&:hover': {
        borderColor: state.isFocused ? 'rgb(234 88 12)' : 'gray',
      },
    }),
  };


  const handleClear = () => {
    setInput1('');
    setInput2('');
    setInput3('');
    setInput4('');
  };

  const handleInputChange = (e, setInput, nextFieldId, prevFieldId) => {
    const { value } = e.target;
    if (/^\d$/.test(value) || value === '') {
      setInput(value);
      if (value && nextFieldId) {
        document.getElementById(nextFieldId).focus();
      }
    }
  };

  const handleKeyDown = (e, prevFieldId) => {
    if (e.key === 'Backspace' && !e.target.value && prevFieldId) {
      document.getElementById(prevFieldId).focus();
    }
  };

  // Countdown timer — navigate back to subscribe if expired
  useEffect(() => {
    if (time > 0) {
      const timer = setTimeout(() => setTime(time - 1), 1000);
      return () => clearTimeout(timer);
    } else {
      Cookies.remove('extId');
      Cookies.remove('number');
      Cookies.remove('pack');
Cookies.remove("t");
      navigate(`/subscribe`);
    }
  }, [time]);

  // ─── Step 2: Call POST /api/v1/matched-otp ────────────────────────────────
//   const redirectUser = async (e) => {
//     e.preventDefault();

//     const otp = input1 + input2 + input3 + input4;
//     console.log('OTP entered:', otp);

//     if (otp.length < 4) {
//       toast.warn("Entrez d'abord OTP !!");
//       return;
//     }

//     setLoading(true);

//     try {
//       const payload = {
//         otp: otp,
//         otpId: otpId,
//         packType: pack,
//         extId: extId,
//         t: tVal,
//         serviceName: "ToonFlix",
//         msisdn: msisdn
//       };

//       console.log("Matching OTP with payload:", payload);

//       const res = await axios.post(`${base_url_toonflix}/api/v1/matched-otp`, payload);
//       console.log("Match OTP response:", res.data);

      


// if (res.status === 200) {
//     toast.success("OTP correspondant !!");
//     navigate("/home");
// }


//     } catch (err) {
//       console.log(err);
//       toast.error(err?.response?.data?.message || 'Échec de la vérification OTP');
//     }

//     handleClear();
//     setLoading(false);
//   };

const redirectUser = async (e) => {
    e.preventDefault();

    const otp = input1 + input2 + input3 + input4;
    console.log('OTP entered:', otp);

    if (otp.length < 4) {
      toast.warn("Entrez d'abord OTP !!");
      return;
    }

    setLoading(true);

    try {
      const payload = {
        otp: otp,
        otpId: otpId,
        packType: pack,
        extId: extId,
        t: tVal,
        serviceName: "ToonFlix",
        msisdn: msisdn
      };

      console.log("Matching OTP with payload:", payload);

      const res = await axios.post(`${base_url_toonflix}/api/v1/matched-otp`, payload);
      console.log("Match OTP response:", res.data);

      if (res.data?.statusCode === 200 && res.data?.code === 'SUCCESS') {
        toast.success(res.data?.message || "OTP correspondant !!");
        navigate(`/home?msisdn=${msisdn}`);
      } else if (res.data?.statusCode === 200 && res.data?.code === 'BILLING_PENDING') {
        toast.info(res.data?.message || "Facturation en attente.");
      } else {
        toast.error(res.data?.message || 'Échec de la vérification OTP');
      }

    } catch (err) {
      console.log(err);

      const status = err?.response?.status;
      const msg = err?.response?.data?.message;
      const code = err?.response?.data?.code;

      if (status === 409 && code === 'ACTIVE_SUBSCRIPTION') {
        toast.info(msg || "Abonnement déjà actif.");
        navigate(`/home?msisdn=${msisdn}`);
      } else {
        toast.error(msg || 'Échec de la vérification OTP');
      }
    }

    handleClear();
    setLoading(false);
  };

  return (
    <>
      <div className="fixed inset-0 overflow-y-auto bg-black/90 flex justify-center items-center z-10">
        <div className="container mx-auto max-w-screen-sm bg-white rounded-md p-4 md:p-8 flex flex-col items-center shadow-lg relative">
          <img
            src={toonflix}
            alt="/"
            className="w-24 h-auto mb-4 md:mb-0 md:w-[200px]"
          />
          <div className="flex flex-col w-full md:w-2/3 px-4 py-4 md:py-8">
            <div className="text-center">
              <form onSubmit={redirectUser} className='max-w-lg rounded-md flex flex-col justify-center items-center' style={{
                width: '100%',
                backgroundColor: 'rgba(255, 255, 255, 0.2)',
                backdropFilter: 'blur(10px)',
                border: '1px solid grey',
                padding: '20px',
              }}>
                <h1 className='text-black text-center text-2xl font-bold md:text-4xl mt-5'>
                  Validation OTP
                </h1>
                <p className='text-black text-xl font-semibold mt-1'>
                  Saisissez l'OTP envoyé à votre numéro de mobile :
                </p>
                <br />
                <div className='flex justify-center gap-2'>
                  <input id="input1" className='h-10 w-10 outline-none text-center font-sans text-xl text-black rounded-md border border-black bg-white' placeholder="" type="tel" maxLength="1" value={input1} onChange={(e) => handleInputChange(e, setInput1, 'input2', null)} onKeyDown={(e) => handleKeyDown(e, null)} />
                  <input id="input2" className='h-10 w-10 outline-none text-center font-sans text-xl text-black rounded-md border border-black bg-white' placeholder="" type="tel" maxLength="1" value={input2} onChange={(e) => handleInputChange(e, setInput2, 'input3', 'input1')} onKeyDown={(e) => handleKeyDown(e, 'input1')} />
                  <input id="input3" className='h-10 w-10 outline-none text-center font-sans text-xl text-black rounded-md border border-black bg-white' placeholder="" type="tel" maxLength="1" value={input3} onChange={(e) => handleInputChange(e, setInput3, 'input4', 'input2')} onKeyDown={(e) => handleKeyDown(e, 'input2')} />
                  <input id="input4" className='h-10 w-10 outline-none text-center font-sans text-xl text-black rounded-md border border-black bg-white' placeholder="" type="tel" maxLength="1" value={input4} onChange={(e) => handleInputChange(e, setInput4, null, 'input3')} onKeyDown={(e) => handleKeyDown(e, 'input3')} />
                </div>
                <br />
                <p>OTP expirera dans {time}s</p>
                <button
                  disabled={loading}
                  id="otp-send"
                  type="submit"
                  className="text-white mt-2 w-48 bg-orange-600 hover:bg-orange-800 focus:ring-4 focus:ring-orange-300 font-medium rounded-lg text-sm px-7 py-2.5 mr-2 mb-2 focus:outline-none"
                >
                  {loading ? "Chargement..." : "s'abonner"}
                </button>
               
              </form>

              
            </div>
          </div>

           <p
                  onClick={() => navigate('/tnc')}
                  className="text-blue-700 text-center underline cursor-pointer mb-2"
                >
                  Conditions générales
                </p>
               {/* <span className='text-xs font-semibold w-full text-center'> */}
               <span className="block text-xs font-semibold text-center w-full break-words px-4">

                • Désinscription gratuite à tout moment : composez #303#10#.</span>
        {/* <span className='text-xs font-semibold w-full text-center'> */}
        <span className="block text-xs font-semibold text-center w-full break-words px-4 mt-1">

          •Pour toute question ou assistance, veuillez contacter notre service client ou visiter notre page d'assistance, c'est-à-direpanz.support1@panzcon.com</span>
        </div>
      </div>
    </>
  );
};

export default Otp;







